/**
 * Frist für die Vertragsverlängerung durch die Eltern (#1344): so viele Tage
 * nach dem Anstoßen der Verlängerung. Mail-Text, `renewalInfo.dueDate` und die
 * Fristerinnerungen (7 und 1 Tag vorher) hängen alle an diesem Wert.
 *
 * Kopie von functions/src/_shared/contract-renewal.utils.ts, geprüft in
 * apps/parity-tests/contract-renewal.parity.spec.ts — Änderungen immer in BEIDEN Dateien.
 */
export const CONTRACT_RENEWAL_PERIOD_DAYS = 14;

/** Fristende der Verlängerung, ausgehend vom Zeitpunkt, an dem sie angestoßen wird. */
export function contractRenewalDueDate(from: Date): Date {
  const due = new Date(from.getTime());
  due.setDate(due.getDate() + CONTRACT_RENEWAL_PERIOD_DAYS);
  return due;
}
